import { Box, Divider, Grid, TextField, Typography } from "@mui/material";
import styled from "styled-components";
import { theme } from "styles/mui-config";
import AppbarCM from "components/appbar";

export const StyledAppbarCM = styled(AppbarCM)`
  // direction: rtl !important;
`;

export const LeftGrid = styled(Grid)`
  height: 100%;
  margin: auto 0;
  display: flex;
  justify-content: start;
  align-items: center;
  margin-left: -25px !important;
  ${theme.breakpoints.down("sm")} {
    display: none;
  }
`;
export const RightGrid = styled(Grid)`
  height: 100%;
  margin: auto 0 !important;
  border-radius: 15px;
  display: flex;
  justify-content: center;
  align-items: center;
  & > div {
    min-height: 506px;
    display: flex;
    flex-direction: column !important;
    justify-content: space-evenly;
    align-items: center;
    width: 60%;
    @media (max-width: 900px) {
      width: 85%;
    }
  }
`;
export const StyledInput = styled(TextField)`
  background-color: white !important;
  & > div,
  & > div:hover,
  & > div:focus {
    background-color: white;
  }
  border-radius: 5px;
  ${theme.breakpoints.down("sm")} {
    margin-bottom: 20px !important;
  }
`;
export const StyledTitle = styled(Typography)`
  color: ${theme.palette.primary.main};
  font-weight: bolder !important;
  align-self: center;
  font-family: "Avini";
  margin-top: 10px !important;
  margin-bottom: 10px !important;
  ${theme.breakpoints.down("sm")} {
    margin-top: 50px !important;
    margin-bottom: 50px !important;
  }
`;

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
`;
export const ForgetPassWrapper = styled(Box)`
  margin-top: -20px;
  ${theme.breakpoints.down("sm")} {
    margin-top: 10px;
  }
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 5px;
  & > :first-child {
    border-color: ${theme.palette.primary.dark} !important;
    width: 90%;
    margin: 5px 0;
  }
  & > :last-child {
    font-size: 12px;
  }
`;
export const StyledDivider = styled(Divider)`
  font-size: 12px;
  align-items: flex-start;
`;
export const StyledForgetPassText = styled(Typography)`
  font-size: 12px !important;
  cursor: pointer;
`;
